import type { IconProps } from './types';

export const IconSolidSlack = ({ size = '1em', fill, ...props }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
    <g id="Slack logo" clipPath="url(#clip0_10939_406962)">
      <path
        id="path2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.44434 10.0775C4.44434 9.14544 5.14913 8.39508 6.02458 8.39508C6.90004 8.39508 7.60483 9.14544 7.60483 10.0775V14.2188C7.60483 15.1509 6.90004 15.9013 6.02458 15.9013C5.14913 15.9013 4.44434 15.1509 4.44434 14.2188V10.0775Z"
        fill={fill ?? '#E01E5A'}
        stroke="#E01E5A"
        strokeWidth="0.197531"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0774 11.5556C9.14538 11.5556 8.39502 10.8508 8.39502 9.97533C8.39502 9.09987 9.14538 8.39508 10.0774 8.39508H14.2188C15.1508 8.39508 15.9012 9.09987 15.9012 9.97533C15.9012 10.8508 15.1508 11.5556 14.2188 11.5556H10.0774Z"
        fill={fill ?? '#ECB22D'}
        stroke="#ECB22D"
        strokeWidth="0.197531"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path6"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.39502 1.78116C8.39502 0.849115 9.09981 0.0987549 9.97527 0.0987549C10.8507 0.0987549 11.5555 0.849115 11.5555 1.78116V5.9225C11.5555 6.85457 10.8507 7.60493 9.97527 7.60493C9.09981 7.60493 8.39502 6.85457 8.39502 5.9225V1.78116Z"
        fill={fill ?? '#2FB67C'}
        stroke="#2FB67C"
        strokeWidth="0.197531"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path8"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.78104 7.60495C0.848993 7.60495 0.0986328 6.90016 0.0986328 6.0247C0.0986328 5.14925 0.848993 4.44446 1.78104 4.44446H5.92237C6.85444 4.44446 7.6048 5.14925 7.6048 6.0247C7.6048 6.90016 6.85444 7.60495 5.92237 7.60495H1.78104Z"
        fill={fill ?? '#36C5F1'}
        stroke="#36C5F1"
        strokeWidth="0.197531"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="g18">
        <path
          id="path10"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.39502 14.321C8.39458 14.5286 8.43515 14.7343 8.51441 14.9262C8.59367 15.1182 8.71005 15.2925 8.85688 15.4394C9.00371 15.5862 9.17809 15.7026 9.37001 15.7818C9.56194 15.8611 9.76762 15.9017 9.97527 15.9012C10.8507 15.9012 11.5555 15.1964 11.5555 14.321C11.556 14.1133 11.5154 13.9076 11.4361 13.7157C11.3569 13.5238 11.2405 13.3494 11.0937 13.2026C10.9468 13.0558 10.7725 12.9394 10.5805 12.8601C10.3886 12.7809 10.1829 12.7403 9.97527 12.7407H8.39502V14.321Z"
          fill={fill ?? '#ECB22D'}
          stroke="#ECB22D"
          strokeWidth="0.197531"
          strokeLinecap="round"
        />
        <path
          id="path12"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.321 7.60495H12.7407V6.0247C12.7407 5.14925 13.4455 4.44446 14.321 4.44446C15.1964 4.44446 15.9012 5.14925 15.9012 6.0247C15.9012 6.90016 15.1964 7.60495 14.321 7.60495Z"
          fill={fill ?? '#2FB67C'}
          stroke="#2FB67C"
          strokeWidth="0.197531"
          strokeLinecap="round"
        />
        <path
          id="path14"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.67888 8.39508H3.25913V9.97533C3.25913 10.8508 2.55434 11.5556 1.67888 11.5556C1.47124 11.556 1.26555 11.5154 1.07363 11.4362C0.881701 11.3569 0.70732 11.2405 0.560493 11.0937C0.413665 10.9469 0.297282 10.7725 0.218024 10.5806C0.138766 10.3887 0.0981937 10.183 0.0986364 9.97533C0.0986364 9.09987 0.803426 8.39508 1.67888 8.39508Z"
          fill={fill ?? '#E01E5A'}
          stroke="#E01E5A"
          strokeWidth="0.197531"
          strokeLinecap="round"
        />
        <path
          id="path16"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.60483 1.67901V3.25925H6.02459C5.81694 3.25969 5.61125 3.21912 5.41933 3.13986C5.2274 3.06061 5.05302 2.94422 4.9062 2.7974C4.75937 2.65057 4.64298 2.47619 4.56373 2.28426C4.48447 2.09234 4.4439 1.88665 4.44434 1.67901C4.44434 0.803548 5.14913 0.0987585 6.02459 0.0987585C6.23223 0.0983158 6.43792 0.138888 6.62984 0.218146C6.82177 0.297404 6.99615 0.413787 7.14298 0.560615C7.2898 0.707442 7.40619 0.881823 7.48544 1.07375C7.5647 1.26567 7.60528 1.47136 7.60483 1.67901Z"
          fill={fill ?? '#36C5F1'}
          stroke="#36C5F1"
          strokeWidth="0.197531"
          strokeLinecap="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_10939_406962">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
